/**
 * expirySlice — per-symbol expiry date lists.
 *
 * Rarely changing reference data. Separated from live/history data so expiry
 * updates never trigger tick-driven re-renders.
 */
import type { StateCreator } from 'zustand'
import type { MarketStore, ExpiryState } from './types'

export const createExpirySlice: StateCreator<MarketStore, [], [], ExpiryState> = (set) => ({
    expiryMap: {},
    expiryList: [], // Computed from expiryMap for backward compat

    setExpiryList: (list) => set({ expiryList: list }), // Legacy shim
    setExpiryForSymbol: (symbol, list) =>
        set((state) => {
            const newMap = { ...state.expiryMap, [symbol]: list }
            return {
                expiryMap: newMap,
                expiryList: list, // Also update flat list for backward compat
            }
        }),
})
